import type { DeepString } from "@/lib/i18n";

/**
 * CRegisterationToNewsletters - polskie tłumaczenia.
 *
 * Wartości używane jako fallback gdy backend `content.lang.*` nie dostarczy
 * stringa (backend ZAWSZE powinien dostarczyć) + komunikaty walidacyjne +
 * statusy systemowe (rate limit, anti-spam delay, sieć).
 */
export const pl = {
  /* ─── System errors / stany puste ─── */
  noConfig: "Brak danych konfiguracji formularza.",
  noCategorys: "Brak kategorii newslettera, do których można się zapisać.",

  /* ─── Nagłówki / chrome ─── */
  topInfo: "Zapraszamy do zapisania się do naszego newslettera.",
  topInfo2: "Informacje na jaki temat chciałbyś otrzymywać?",
  categoriesHeader: "Kategorie newslettera",
  additionalDataHeader: "Dane subskrybenta",
  loggedInIntro: (email: string) =>
    email
      ? `Ustawiasz kategorie newslettera dla swojego konta (${email}) - nie dla adresu wpisanego wcześniej. Zaznacz, które chcesz otrzymywać.`
      : "Zarządzaj subskrypcjami swojego konta - zaznacz kategorie, które chcesz otrzymywać.",
  save: "Zapisz się",
  saveLoggedIn: "Zaktualizuj subskrypcje",
  saving: "Zapisywanie...",
  emailLabel: "E-mail",

  /* ─── Walidacja ─── */
  validation: {
    /** `requiredField('Imię')` -> `Pole "Imię" jest wymagane.` */
    requiredField: (label: string) => `Pole "${label}" jest wymagane.`,
    selectCategory: "Prosimy o wybór co najmniej jednej kategorii.",
    invalidEmail: "Niepoprawny adres email.",
    notAcceptedRegulamin: "Nie zaakceptowano regulaminu.",
    notAcceptedPersonalData: "Musisz wyrazić zgodę na przetwarzanie swoich danych osobowych.",
    notAcceptedMarketing: "Nie wyrażono zgody na wysyłkę.",
  },

  /* ─── Statusy submitu / errory systemowe ─── */
  status: {
    /** `waitBeforeSubmit(seconds)` -> `Poczekaj jeszcze N sekund przed wysłaniem.` */
    waitBeforeSubmit: (seconds: number) =>
      `Poczekaj jeszcze ${seconds} sekund przed wysłaniem.`,
    rateLimit: "Zbyt wiele prób z tego adresu IP. Spróbuj za chwilę.",
    subscribeFailed: "Nie udało się zapisać do newslettera.",
    subscribeSuccess: "Zostałeś zapisany do newslettera, dziękujemy!",
    updateSuccess: "Twoje subskrypcje zostały zaktualizowane.",
    /** `networkError(message)` -> `Błąd sieci: ${message}` */
    networkError: (message: string) => `Błąd sieci: ${message}`,
    networkErrorGeneric: "Błąd sieci podczas zapisu.",
  },
} as const;

export type CRegisterationToNewslettersTranslations = DeepString<typeof pl>;
